import { useClickOutside } from "application";
import { useRef, useState } from "react";
import {
  Container,
  Modal,
  ModalArrow,
  ParcelPrice,
  ViewMore as Text,
} from "./styles";
import { useViewPaymentMethods } from "./ViewPaymentMethods.service";
import { ViewPaymentMethodsProps } from "./ViewPaymentMethods.types";

const ViewMore = ({
  maxNumberInstallments,
  discountPercentage,
  salePrice,
}: ViewPaymentMethodsProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const ModalViewMoreComponentsRef = useRef<HTMLDivElement>(null);

  useClickOutside({
    ref: ModalViewMoreComponentsRef,
    callback: () => {
      if (isModalOpen) {
        setIsModalOpen(false);
      }
    },
  });

  const { installmentsList } = useViewPaymentMethods({
    discountPercentage,
    maxNumberInstallments,
    salePrice,
  });

  return (
    <Container ref={ModalViewMoreComponentsRef}>
      <Text onClick={() => setIsModalOpen(!isModalOpen)}>ver mais</Text>
      <Modal isVisibled={isModalOpen}>
        <ModalArrow />
        {installmentsList?.map((item) => (
          <ParcelPrice key={item}>{item}</ParcelPrice>
        ))}
      </Modal>
    </Container>
  );
};

export { ViewMore };
